import { fromJS } from 'immutable'
import {
  EMPLOYEE_LEVELS_CREATE_REQUEST,
  EMPLOYEE_LEVELS_CREATE_SUCCESS,
  EMPLOYEE_LEVELS_CREATE_FAILURE,
  EMPLOYEE_LEVELS_CREATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case EMPLOYEE_LEVELS_CREATE_REQUEST:
      return state
        .set('isFetching', true)
    case EMPLOYEE_LEVELS_CREATE_SUCCESS:
      return state
        .set('employeeLevelsCreate', fromJS(action.payload.createdEmployee))
        .set('status', 200)
        .set('message', 'Created Successfully.')
        .set('isFetching', false)
    case EMPLOYEE_LEVELS_CREATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('employeeLevelsCreate', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case EMPLOYEE_LEVELS_CREATE_RESET:
      return state
        .delete('employeeLevelsCreate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employee-levels/employee-levels-create-reducer.js